module.exports = __webpack_public_path__ + "media/charts/education-4162020d.svg";